import { render, staticRenderFns } from "./storeSalesRecord.vue?vue&type=template&id=b44ce5f6"
import script from "./storeSalesRecord.vue?vue&type=script&lang=js"
export * from "./storeSalesRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports